import { Link } from 'react-router-dom';
import { articleCards } from '@/mocks/articles';

const articleImageMap: Record<string, string> = {
  'hipobuy-spreadsheet-complete-guide': 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20showing%20organized%20spreadsheet%20product%20data%2C%20clean%20aesthetic%2C%20soft%20natural%20morning%20light%2C%20editorial%20photography%20with%20warm%20neutral%20tones&width=800&height=420&seq=artcard-guide-2026&orientation=landscape',
  'hipobuy-vs-kakobuy-spreadsheet': 'https://readdy.ai/api/search-image?query=Two%20modern%20laptops%20side%20by%20side%20on%20minimal%20wooden%20desk%20showing%20different%20interfaces%2C%20split%20screen%20comparison%20concept%2C%20warm%20natural%20light%2C%20editorial%20style&width=800&height=420&seq=artcard-vs-kakobuy&orientation=landscape',
  'hipobuy-vs-cssbuy-spreadsheet': 'https://readdy.ai/api/search-image?query=Two%20tablets%20displaying%20comparison%20charts%20on%20minimal%20clean%20desk%2C%20warm%20ambient%20lighting%2C%20professional%20tech%20aesthetic%2C%20soft%20shadows&width=800&height=420&seq=artcard-vs-cssbuy&orientation=landscape',
  'hipobuy-vs-superbuy-spreadsheet': 'https://readdy.ai/api/search-image?query=Premium%20dual%20screen%20setup%20showing%20spreadsheet%20data%20comparison%20on%20luxurious%20minimal%20desk%2C%20golden%20hour%20warm%20lighting%2C%20editorial%20photography&width=800&height=420&seq=artcard-vs-superbuy&orientation=landscape',
  'hipobuy-vs-oopbuy-spreadsheet': 'https://readdy.ai/api/search-image?query=Minimal%20desk%20setup%20with%20laptop%20and%20tablet%20showing%20alternative%20spreadsheet%20views%2C%20soft%20morning%20light%20through%20window%2C%20calm%20workspace%20atmosphere&width=800&height=420&seq=artcard-vs-oopbuy&orientation=landscape',
  'best-products-spreadsheet-database': 'https://readdy.ai/api/search-image?query=Person%20browsing%20organized%20product%20catalog%20on%20clean%20modern%20interface%2C%20soft%20natural%20lighting%2C%20editorial%20style%20with%20warm%20minimal%20aesthetic&width=800&height=420&seq=artcard-best-products&orientation=landscape',
  'safety-tips-spreadsheet-shopping': 'https://readdy.ai/api/search-image?query=Security%20shield%20concept%20on%20minimal%20clean%20background%2C%20modern%20editorial%20photography%2C%20soft%20warm%20lighting%2C%20trust%20and%20safety%20aesthetic&width=800&height=420&seq=artcard-safety-tips&orientation=landscape',
  'trending-product-categories': 'https://readdy.ai/api/search-image?query=Trending%20fashion%20items%20collection%20on%20minimal%20clean%20background%2C%20modern%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20lifestyle%20aesthetic&width=800&height=420&seq=artcard-trending&orientation=landscape',
};

export default function ArticleSection() {
  const visibleArticles = articleCards.slice(0, 6);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            <i className="ri-book-read-line w-3 h-3 flex items-center justify-center"></i>
            Knowledge Base
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
            Hipobuy Sheet Knowledge Base
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Expert guides, detailed platform comparisons, and shopping tips to help you navigate the spreadsheet shopping ecosystem.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {visibleArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group block rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-full h-48 md:h-52 overflow-hidden bg-background-100">
                <img
                  src={articleImageMap[article.slug] || articleImageMap['hipobuy-spreadsheet-complete-guide']}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-medium text-accent-600 bg-accent-50 px-2.5 py-1 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="font-semibold text-foreground-900 text-base mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1 mt-4 text-sm font-medium text-accent-600">
                  Read Article
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/article/hipobuy-spreadsheet-complete-guide"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold transition-all duration-300 hover:bg-foreground-800 hover:-translate-y-0.5 cursor-pointer"
          >
            Read Our Complete Guide
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}